import { Box } from '@mui/material';

/**
 * SvgIconSize component renders an icon with specified size and color.
 *
 * @param {Object} props - The properties object.
 * @param {React.ReactNode} props.icon - The icon to be rendered.
 * @param {string} props.iconColor - The color of the icon.
 * @param {'xl' | 'lg' | 'md' | 'sm' | 'xs'} props.size - The size variant of the icon.
 *
 * @returns {JSX.Element} The rendered icon within a Box component.
 */

const SvgIconSize = ({
  icon, size, iconColor, customStyle,
}) => (
  <Box
    className="svg-icon"
    sx={[styles[size], iconColor && { color: iconColor }, customStyle,
    ]}
  >
    {icon}
  </Box>
);

const styles = {
  '& svg': { display: 'block !important' },
  xl: (theme) => ({
    '& :is( svg, img, .MuiSkeleton-root )': {
      display: 'block !important',
      width: theme.iconSizes.xl,
      height: theme.iconSizes.xl,
    },
  }),
  lg: (theme) => ({
    '& :is( svg, img, .MuiSkeleton-root )': {
      display: 'block !important',
      width: theme.iconSizes.lg,
      height: theme.iconSizes.lg,
    },
  }),
  md: (theme) => ({
    '& :is( svg, img, .MuiSkeleton-root )': {
      display: 'block !important',
      width: theme.iconSizes.md,
      height: theme.iconSizes.md,
    },
  }),

  sm: (theme) => ({
    '& :is( svg, img, .MuiSkeleton-root )': {
      display: 'block !important',
      width: theme.iconSizes.sm,
      height: theme.iconSizes.sm,
    },
  }),

  xs: (theme) => ({
    '& :is( svg, img, .MuiSkeleton-root )': {
      display: 'block !important',
      width: theme.iconSizes.xs,
      height: theme.iconSizes.xs,
    },
  }),

}

export default SvgIconSize
